import { useShowExpandNestedContentToggle } from '~/components/ViewControls/ViewVisiblityToggleMenu/hooks/useShowExpandNestedContentToggle';
import { useToggleNestedItems } from '~/hooks/search/useToggleNestedItems';

export type UseCanShowNestedItemsChipParams = {
  /** Share links can lock nested content. Private boards omit this. */
  isDisabled?: boolean;
};

/** The empty-gallery chip. Flatten is already on, so a subboard count is not required to offer a way back. */
export const useCanShowNestedItemsChip = ({ isDisabled = false }: UseCanShowNestedItemsChipParams = {}) => {
  const { showExpandNestedContentToggle } = useShowExpandNestedContentToggle({ isDisabled });
  const { isFlattenedView } = useToggleNestedItems();

  return {
    canShowNestedItemsChip: showExpandNestedContentToggle && isFlattenedView,
  };
};
